<div *ngIf="isLoading" class="overlay">
	<ngb-progressbar type="dark" [value]="60" [striped]="true" height="10px"></ngb-progressbar>
</div>
